<template>
  <SimpleModuleDashboard
    :module-id="Modules.VENDEDORES"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="dashboardActions"
    :widget-filter="filterWidgets"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import Session from '@/handler/session'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({ Modules, Profiles }),
  computed: {
    isSeller() {
      return !!Helper.getSeller()
    },
    sellerObject() {
      return Helper.getSeller()
    },
    showReports() {
      const reportModules = [
        Modules.INFORME_VISITAS,
        Modules.INFORME_COBRANZAS,
        Modules.INFORME_NOVEDADES,
        Modules.INFORME_GENERAL,
      ]
      const permissions = Session.getSession().auth.user.permissions.modules || []
      return permissions.some(module => reportModules.includes(module.id))
    },
    dashboardActions() {
      if(!this.isSeller) {
        return [
          { id: 'crudSellers', reference: 'crudSellers', route: 'SellersStaffCrudSellers', tone: 'primary' },
          { id: 'crudZones', reference: 'crudZones', route: 'SellersStaffCrudZones', tone: 'secondary', group: 'Configuraciones' },
          { id: 'listLocationsSellers', reference: 'listLocationsSellers', route: 'SellersStaffListLocations', tone: 'success' },
        ]
      }

      const actions = [
        { id: 'listCalendarSellers', reference: 'listCalendarSellers', route: 'SellersStaffListCalendar', tone: 'primary' },
        { id: 'listCustomersSellers', reference: 'listCustomersSellers', route: 'SellersStaffListCustomers', tone: 'secondary' },
        { id: 'listLocationsSellers', reference: 'listLocationsSellers', route: 'SellersStaffListLocations', tone: 'success' },
      ]
      if(this.showReports && this.sellerObject) {
        actions.push({
          id: 'crudSellersReports',
          reference: 'crudSellersReports',
          route: 'SellersStaffSellersReports',
          params: { sellersID: this.sellerObject.id },
          tone: 'warning',
        })
      }
      return actions
    },
  },
  methods: {
    filterWidgets(widget) {
      if(widget.reference === 'list_tasks') return this.isSeller
      if([
        'indicator_total_sellers',
        'indicator_sellers_without_locations_today',
        'list_sellers_km_today_month',
      ].includes(widget.reference)) return !this.isSeller
      return true
    },
  },
}
</script>
